export default __webpack_public_path__ + "static/media/dp2023.287e0e1b.jpg";